export class AzureTenant {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureTenant.attributeTypeMap;
    }
    constructor() {
    }
}
